"use client";

/** Listenelement einer Mega-Menü-Spalte. */
export default function MegaMenuItem({ children }: { children: React.ReactNode }) {
  return <li className="min-w-0">{children}</li>;
}
